export default "__VITE_ASSET__BqJta0m8__"